// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1179":"003d3815","4871":"4fe63d88"}[chunkId] + ".chunk.css";
};